import React from "react";
import styled, { css } from "styled-components";
var TooltipSvg = function TooltipSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7 8a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V8ZM8 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7.625"
  }));
};
TooltipSvg.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconSmallSvg = function IconSmallSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6a.75.75 0 0 1 1.5 0v2.25a.75.75 0 0 1-1.5 0V6zM6 3a.75.75 0 1 0 0 1.5A.75.75 0 0 0 6 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0zm-1 0A5 5 0 1 1 1 6a5 5 0 0 1 10 0z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }));
};
IconSmallSvg.defaultProps = {
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconSvg = function IconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1 10.09c0-.56.07-1 .2-1.32.12-.33.32-.6.6-.84.28-.24.49-.46.63-.65.15-.2.22-.42.22-.66 0-.57-.24-.86-.73-.86a.68.68 0 0 0-.55.25c-.14.17-.22.4-.22.68H5.33c.01-.76.25-1.36.72-1.78a2.81 2.81 0 0 1 1.97-.64c.84 0 1.49.2 1.95.59.46.4.7.95.7 1.68 0 .32-.07.6-.19.86s-.32.53-.6.8l-.65.61c-.19.18-.31.37-.39.56-.07.19-.1.43-.12.72H7.11zm-.23 1.74c0-.28.1-.51.3-.7.2-.18.46-.27.76-.27s.56.1.76.28c.2.18.3.4.3.7a.9.9 0 0 1-.3.7c-.2.17-.46.26-.76.26s-.55-.09-.76-.27a.9.9 0 0 1-.3-.7z"
  }));
};
IconSvg.defaultProps = {
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
import { touchTargetSizeSpace, zIndex as zIndexSettings } from "../../../settings";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import isNotEmpty from "../../../utils/isNotEmpty";
import setClickableArea from "../../../utils/setClickableArea";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import TextAtm from "../../atoms/TextAtm";
var iconEmphasis = "high";
export var TooltipWrapper = styled.span.withConfig({
  componentId: "sc-18x0fgh-0"
})(function (_ref) {
  var $isOverlappingRelativeContainer = _ref.$isOverlappingRelativeContainer,
    $zIndex = _ref.$zIndex;
  return css(["display:inline-flex;flex-shrink:0;position:relative;z-index:", ";", " ", ""], $zIndex || 1, $isOverlappingRelativeContainer && css(["position:absolute;top:0;right:0;bottom:0;left:0;> *:first-child{width:100%;height:100%;opacity:0;}"]), setClickableArea(touchTargetSizeSpace / 2));
});
export var Trigger = styled.span.withConfig({
  componentId: "sc-18x0fgh-1"
})(function (_ref2) {
  var $hasHover = _ref2.$hasHover,
    $isActive = _ref2.$isActive,
    $onColor = _ref2.$onColor,
    $iconTouchAreaSpace = _ref2.$iconTouchAreaSpace,
    theme = _ref2.theme;
  return css(["display:flex;border-radius:", ";cursor:help;", " ", ""], $hasHover ? "50%" : "0", $hasHover && css(["padding:", ";cursor:pointer;&:hover{background-color:", ";}", ""], space(0.5), getBorderColor(theme, $onColor, "extraLow"), $isActive && css(["padding:", ";background-color:", ";"], space(0.5), getBorderColor(theme, $onColor, "extraLow"))), isNotEmpty($iconTouchAreaSpace) ? css(["padding:", ";"], space($iconTouchAreaSpace)) : null);
});
export var Icon = styled(IconSvg).withConfig({
  componentId: "sc-18x0fgh-2"
})(function (_ref3) {
  var $onColor = _ref3.$onColor,
    theme = _ref3.theme;
  return css(["fill:", ";"], getBorderColor(theme, $onColor, iconEmphasis));
});
export var IconSmall = styled(IconSmallSvg).withConfig({
  componentId: "sc-18x0fgh-3"
})(function (_ref4) {
  var $onColor = _ref4.$onColor,
    theme = _ref4.theme;
  return css(["fill:", ";"], getBorderColor(theme, $onColor, iconEmphasis));
});
export var IconLarge = styled(TooltipSvg).withConfig({
  componentId: "sc-18x0fgh-4"
})(function (_ref5) {
  var $onColor = _ref5.$onColor,
    theme = _ref5.theme;
  return css(["path{fill:", ";}circle{stroke:", ";}"], getBorderColor(theme, $onColor, iconEmphasis), getBorderColor(theme, $onColor, iconEmphasis));
});
export var Button = styled.button.withConfig({
  componentId: "sc-18x0fgh-5"
})(function (_ref6) {
  var $onColor = _ref6.$onColor,
    $hasInheritedLabelTypography = _ref6.$hasInheritedLabelTypography,
    theme = _ref6.theme;
  return css(["width:fit-content;padding:", " ", " ", " ", ";border:0;border-radius:", ";background-color:transparent;line-height:", ";cursor:pointer;&:hover{background:", ";}p{display:flex;align-items:center;span{position:static;}svg{margin-left:", ";}}", ""], unit(2), unit(10), unit(2), unit(12), getBorderRadius(theme, "xlarge"), unit(16), getBorderColor(theme, $onColor, "extraLow"), space(0.5), $hasInheritedLabelTypography ? css(["font-size:inherit;color:inherit;font-weight:inherit;line-height:revert;"]) : null);
});
var textCommonStyles = css(["align-items:center;gap:", ";"], unit(2));
export var StyledTextAtm = styled(TextAtm).withConfig({
  componentId: "sc-18x0fgh-6"
})(["display:flex;", ""], textCommonStyles);
export var StyledSpan = styled.span.withConfig({
  componentId: "sc-18x0fgh-7"
})(["display:inline-flex;", ""], textCommonStyles);
export var Overlay = styled.div.withConfig({
  componentId: "sc-18x0fgh-8"
})(function () {
  return css(["position:fixed;z-index:", ";top:0;right:0;bottom:0;left:0;background-color:transparent;"], zIndexSettings.ModalOrg + 1);
});